// extracted by mini-css-extract-plugin
export default {"PurchaseBlock":"PurchaseBlockYVaf7","purchaseBlock":"PurchaseBlockYVaf7"};